module.exports = __webpack_public_path__ + "img/自動化控制.3f23b1a6.svg";